var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeftSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03486 5.39543C0.741953 5.73014 0.741953 6.27371 1.03486 6.60842L5.53398 11.7496C5.8269 12.0843 6.63247 12.0843 6.92538 11.7496C7.21829 11.4148 7.29108 10.8353 6.99817 10.5006L3.31518 6.00059L6.92538 1.50059C7.21829 1.16588 7.29108 0.586327 6.99817 0.251618C6.70526 -0.0830915 5.98041 -0.0854776 5.6875 0.249232L1.03252 5.39275L1.03486 5.39543Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftSolid);
export default __webpack_public_path__ + "static/media/chevron-left-solid.f51e45d6a4b49bac601011f03022717e.svg";
export { ForwardRef as ReactComponent };